import { Atom, Download } from "lucide-react";
import { cn } from "@/lib/utils";

// Qastle Wallet by Krown Technologies — THE KROWN Network (chain 1983) wallet. Never "Krown Wallet".
export const QASTLE = {
  site: "https://qastlewallet.com",
  ios: "https://apps.apple.com/app/id6753584131",
  android: "https://play.google.com/store/apps/details?id=com.krown.network.qastlewallet",
  chrome: "https://chromewebstore.google.com/detail/ajafaiinalikbajcekgobhcheniojeoi",
};

// "Get Qastle" install card — shown on KROWN-gated BLOQs that need a linked wallet and under the wallet picker.
export function GetQastleCard({ compact = false, className, testid = "get-qastle-card" }) {
  return (
    <div className={cn("rounded-2xl border border-bloq-mint/30 bg-gradient-to-br from-bloq-mint/10 to-bloq-s2 p-4", className)} data-testid={testid}>
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-bloq-mint/20 text-bloq-mint"><Atom className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-1.5">
            <span className="text-sm font-bold text-white">Get Qastle Wallet</span>
            <span className="rounded-full bg-bloq-mint px-1.5 py-0.5 text-[9px] font-black uppercase tracking-wide text-bloq-bg">Recommended for KROWN</span>
          </div>
          {!compact && <p className="mt-1 text-xs text-bloq-muted">The quantum-secure wallet for KROWN Network (chain 1983). Connects to BLOQ Talk over WalletConnect in one tap.</p>}
          <div className="mt-2.5 flex flex-wrap gap-1.5">
            {[["iOS", QASTLE.ios], ["Android", QASTLE.android], ["Chrome", QASTLE.chrome], ["qastlewallet.com", QASTLE.site]].map(([label, href]) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 rounded-full border border-bloq-mint/40 px-2.5 py-1 text-[11px] font-semibold text-bloq-mint hover:bg-bloq-mint/10" data-testid={`${testid}-${label.toLowerCase().replace(/\W+/g, "-")}`}>
                <Download className="h-3 w-3" /> {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
